// src/components/Loader.js
import React from 'react';

export default function Loader({ fullPage = false, size = 'md' }) {
  const sizes = { sm: 'w-5 h-5', md: 'w-8 h-8', lg: 'w-12 h-12' };

  const spinner = (
    <div className="flex flex-col items-center gap-3">
      <div
        className={`${sizes[size]} border-3 border-rose-100 border-t-rose-500 rounded-full animate-spin`}
        style={{ borderWidth: 3 }}
      />
      {fullPage && (
        <p className="text-rose-400 text-sm font-body animate-pulse">Loading...</p>
      )}
    </div>
  );

  if (fullPage) {
    return (
      <div className="fixed inset-0 bg-white/80 backdrop-blur-sm z-50 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-16 h-16 bg-gradient-to-br from-rose-400 to-rose-600 rounded-full flex items-center justify-center animate-heartbeat shadow-rose-lg">
            <span className="text-white text-2xl">♡</span>
          </div>
          <p className="text-gray-400 text-sm font-body animate-pulse">Just a moment...</p>
        </div>
      </div>
    );
  }

  return spinner;
}

export function SkeletonCard() {
  return (
    <div className="bg-white rounded-3xl overflow-hidden shadow-soft animate-pulse">
      <div className="aspect-square bg-rose-50" />
      <div className="p-4 space-y-3">
        <div className="h-4 bg-rose-50 rounded-full w-3/4" />
        <div className="h-3 bg-rose-50 rounded-full w-1/2" />
        <div className="flex justify-between items-center">
          <div className="h-5 bg-rose-50 rounded-full w-1/3" />
          <div className="w-9 h-9 bg-rose-50 rounded-full" />
        </div>
      </div>
    </div>
  );
}
